import { Panel } from "primereact/panel"
import { ReferenciaBancaria } from "../ReferenciaBancaria";
import { useState } from "react";
import { DeclaracionCpn } from "../../../models/cpn/DeclaracionCpn";
import { Divider } from "primereact/divider";
import { Generico } from "../../../components/Generico";
import { Dialog } from "primereact/dialog";
import { FileBvg } from "../../../components/FileBvg";
import { FileComponent } from "../../../components/FileComponent";
import { Button } from "primereact/button";
import { ReferenciaComercial } from "../ReferenciaComercial";
import { FuncionarioService } from "../../../service/ficha/FuncionarioService";

export const AmpliadaAccionsista = ({ id, toast, tipo, permss, setDialogClientepn, cancelar, generic, urls, estado, reiniciar, handlePrev }) => {
    const omodel = new DeclaracionCpn();
    const { buttonsFormsReports, funcMessageBlobError, downloadPdf } = Generico();
    const accSrv = new FuncionarioService();
    const [loadReport, setLoadReport] = useState(false);
    const [dialogSubir, setDialogSubir] = useState(false);
    const { enviarFormularioPep } = FileComponent({ generic, toast });

    const generarReporte = (opcion = true) => {
        setLoadReport(true);
        const url = 'accionista-' + (opcion ? 'principal' : 'declaracion') + '-pn-bvg';
        accSrv.descargar(id, url, id).then(res => {
            const nombre = opcion ? '-Formulario-Declarante.pdf' : '-Formulario-declaracion.pdf';
            downloadPdf(res, id + nombre);
            setLoadReport(false);
        }).catch(error => {
            setLoadReport(false);
            funcMessageBlobError('Complete la información antes de generar.', error, toast);
        });
    }

    const subirReporte = () => {
        setDialogSubir(true);
    }

    const enviar = () => {
        enviarFormularioPep(id, urls.uenviar, tipo, reiniciar, setLoadReport);
    }

    return (
        <>
            <ReferenciaBancaria tipo={tipo} id={id} toast={toast} permss={permss} bvg={true} num={5} />
            <br />

            <ReferenciaComercial tipo={tipo} id={id} toast={toast} permss={permss} bvg={true} num={6} />
            <br />

            <Panel header="DECLARACIÓN Y AUTORIZACIÓN" className="panel-ficha">
                <div className="formgrid grid">
                    <div className="field col-12" style={{ textAlign: 'justify', fontStyle: 'italic', fontSize: '10px' }}>
                        {omodel.strBVG}
                    </div>
                    <div className="field col-5 h-2rem" style={{ textAlign: 'center', fontStyle: 'italic', fontSize: '10px', verticalAlign: 'bottom', fontWeight: 'bold' }}>
                        <Divider />
                        <span>Firma del Declarante</span>
                    </div>
                    <Divider />
                    {omodel.decBVG}
                </div>
            </Panel>
            <br />

            <Panel header="INFORMACIÓN Y DOCUMENTACIÓN ANEXA (CHECK LIST)." className="panel-ficha">
                <div className="formgrid grid">
                    <div className="field col-5">
                        {omodel.bgvAnexo}
                    </div>
                    <div className="field col-1">
                        <Divider layout="vertical" />
                    </div>
                    <div className="field col-6">
                        {omodel.bvgRespaldo}
                    </div>
                </div>
            </Panel>
            <br />

            <div className="formgrid grid">
                <div className="field col-3">
                    <span style={{ fontStyle: 'italic', fontSize: '10px', fontWeight: 'bold' }}>*Descargar Declaración de Origen Lícito de Recursos</span><br />
                    <Button label="Anterior" type="button" icon="pi pi-chevron-left" onClick={e => { handlePrev(); }} />
                    &nbsp;
                    <Button label="Declaración*" icon="pi pi-print" type="button" className="p-button-warning" onClick={() => generarReporte(false)}
                        loading={loadReport} disabled={loadReport} title='Generar Declaración de Origen Lícito de Recursos en PDF' />
                </div>
                <div className="field col-9" style={{ textAlign: 'center' }}>
                    {buttonsFormsReports(setDialogClientepn, generarReporte, subirReporte, enviar, loadReport, id != null, cancelar, false)}
                </div>
            </div>

            <Dialog visible={dialogSubir} header="Gestión de anexos" modal className="p-fluid modal-ssize" onHide={e => setDialogSubir(false)} style={{ width: '800px' }}>
                <FileBvg generic={generic} tipo={tipo} urls={urls} idp={id} toast={toast} permss={permss} estado={estado} reiniciar={reiniciar} setDialogSubir={setDialogSubir} />
            </Dialog>
        </>
    )
}
